module.exports = __webpack_public_path__ + "TiemposFine-BlackItalic.svg?fa80ca1924f0cbef8a2ce0ea22a8daa2";